import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-108" data-mp="2z2p6yys9pdtb">
      <div className="mx-auto max-w-2xl" data-id="element-109" data-mp="2z51xw1g06yii">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-brandred" data-id="element-110" data-mp="3msjjff8od0d1">
          ❓ Dudas frecuentes
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-navy sm:text-4xl" data-id="element-111" data-mp="3rr4gx6wjl5xs">
          Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-112" data-mp="3i0s1tu7hy4z1">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-113" data-mp="9k6ra8z7v3tt" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-114" data-mp="eeufs7u7zy8e">
                  <span className="text-[14.5px] font-bold leading-snug text-navy" data-id="element-115" data-mp="2ai2y5wzlmgti">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brandred transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} strokeWidth={2.5} data-id="element-116" data-mp="25o8jx92riu1t" />
                </button>
                <AnimatePresence initial={false} data-id="element-117" data-mp="2te2vzof9cel0">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeOut'
              }} data-id="element-118" data-mp="2og18mrastt3q">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy/65" data-id="element-119" data-mp="1jrgy5i5owkfe">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <TransformCTA text="Resolví mis dudas, quiero acceder ahora" data-id="element-120" data-mp="1st6oeknu5dbl" />
      </div>
    </section>;
}